import type { accountMenu as en } from '@/i18n/locales/en/accountMenu';
import type { Translation } from '@/i18n/types';

export const accountMenu: Translation<typeof en> = {
  trigger: 'Account',
  viewProfile: 'Visualizza profilo',
  roles: {
    admin: 'Amministratore della piattaforma',
    companyAdmin: "Amministratore dell'azienda",
    departmentAdmin: 'Amministratore/allenatore del reparto',
  },
  company: {
    label: 'Azienda',
    switchTo: 'Passa a {{name}}',
  },
  accounts: {
    label: 'Altri account',
    switchTo: 'Passa a {{name}}',
    addAnother: 'Accedi con un altro account',
  },
  manage: 'Gestisci',
  settings: 'Profilo aziendale',
  language: 'Lingua',
  theme: {
    label: 'Tema',
    light: 'Chiaro',
    dark: 'Scuro',
    system: 'Sistema',
  },
  signOut: 'Esci',
  signOutAll: 'Esci da tutti gli account',
};
